var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomizableAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4254",
    "data-name": "Group 4254",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5070",
    "data-name": "Path 5070",
    d: "M294.129,286.049v-5.969l-2.286-.584c-.016-.039-.032-.077-.048-.115l1.2-2.029-4.221-4.221-2.029,1.2-.115-.048L286.049,272h-5.969l-.584,2.286-.115.048-2.029-1.2-4.221,4.221,1.2,2.029-.048.115L272,280.08v5.969l2.286.584c.016.039.032.077.048.115l-1.2,2.029L277.352,293l2.029-1.2.115.048.584,2.286h5.969l.584-2.286.115-.048,2.029,1.2L293,288.777l-1.2-2.029.048-.115Zm-3.116,2.479-2.485,2.485-1.689-1-.38.182a7.923,7.923,0,0,1-.753.312l-.4.141-.485,1.9h-3.515l-.485-1.9-.4-.141a7.45,7.45,0,0,1-.753-.312l-.38-.182-1.689,1-2.485-2.485,1-1.689-.182-.38a7.915,7.915,0,0,1-.312-.753l-.141-.4-1.9-.485v-3.515l1.9-.485.141-.4a7.45,7.45,0,0,1,.312-.753l.182-.38-1-1.689,2.485-2.485,1.689,1,.38-.182a7.919,7.919,0,0,1,.753-.312l.4-.141.485-1.9h3.515l.485,1.9.4.141a7.459,7.459,0,0,1,.753.312l.38.182,1.689-1,2.485,2.485-1,1.689.182.38a7.919,7.919,0,0,1,.312.753l.141.4,1.9.485v3.515l-1.9.485-.141.4a7.459,7.459,0,0,1-.312.753l-.182.38Zm0,0",
    transform: "translate(-245.129 -245.129)",
    fill: "#96006b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5071",
    "data-name": "Path 5071",
    d: "M326.323,320a6.323,6.323,0,1,0,6.323,6.323A6.33,6.33,0,0,0,326.323,320Zm0,11.065a4.742,4.742,0,1,1,4.742-4.742A4.747,4.747,0,0,1,326.323,331.065Zm0,0",
    transform: "translate(-288.387 -288.387)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5072",
    "data-name": "Path 5072",
    d: "M355.161,352a3.161,3.161,0,1,0,3.161,3.161A3.164,3.164,0,0,0,355.161,352Zm0,4.742a1.581,1.581,0,1,1,1.581-1.581A1.582,1.582,0,0,1,355.161,356.742Zm0,0",
    transform: "translate(-317.226 -317.226)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5073",
    "data-name": "Path 5073",
    d: "M157,13.382a4.75,4.75,0,0,0,1.324,2v.67l-3.758,1.409a3.969,3.969,0,0,0-2.565,3.7V25.29h18.968V21.159a3.971,3.971,0,0,0-2.564-3.7l-3.759-1.409v-.67a4.74,4.74,0,0,0,1.324-2,3.16,3.16,0,0,0,2.628-3.108V7.113a7.113,7.113,0,0,0-14.226,0v3.161A3.16,3.16,0,0,0,157,13.382Zm6.066,3-1.581,2.634L159.9,16.378V16.32a4.653,4.653,0,0,0,3.161,0Zm-4.291,1.19,1.593,2.655-1.583.791-1.023-3.066Zm10.613,3.59V23.71H153.581V21.159a2.382,2.382,0,0,1,1.539-2.22l1.162-.435,1.58,4.74,3.623-1.811,3.623,1.811,1.58-4.74,1.163.436a2.38,2.38,0,0,1,1.538,2.219Zm-4.181-3.211-1.023,3.067-1.583-.791,1.593-2.655Zm-3.722-2.931a3.164,3.164,0,0,1-3.161-3.161V8.64a6.118,6.118,0,0,0,3.161-1.262,6.111,6.111,0,0,0,3.161,1.262v3.215A3.164,3.164,0,0,1,161.484,15.016Zm4.742-3.381V8.914a1.566,1.566,0,0,1,0,2.721ZM161.484,1.581a5.539,5.539,0,0,1,5.532,5.532v.44a3.127,3.127,0,0,0-1.581-.44H165.3a4.574,4.574,0,0,1-3.257-1.349l-.559-.56-.559.56a4.575,4.575,0,0,1-3.257,1.349h-.136a3.127,3.127,0,0,0-1.581.44v-.44A5.539,5.539,0,0,1,161.484,1.581Zm-4.742,7.332v2.721a1.566,1.566,0,0,1,0-2.721Zm0,0",
    transform: "translate(-136.984)",
    fill: "#96006b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5074",
    "data-name": "Path 5074",
    d: "M0,308.548H15.806V288H0Zm1.581-18.968H14.226v17.387H1.581Zm0,0",
    transform: "translate(0 -259.548)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4236",
    "data-name": "Group 4236",
    transform: "translate(3.161 31.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5075",
    "data-name": "Path 5075",
    d: "M32,320h9.484v1.581H32Zm0,0",
    transform: "translate(-32 -320)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5076",
    "data-name": "Path 5076",
    d: "M32,352h1.581v1.581H32Zm0,0",
    transform: "translate(-32 -348.839)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5077",
    "data-name": "Path 5077",
    d: "M64,352h6.323v1.581H64Zm0,0",
    transform: "translate(-60.839 -348.839)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5078",
    "data-name": "Path 5078",
    d: "M32,384h9.484v1.581H32Zm0,0",
    transform: "translate(-32 -377.677)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5079",
    "data-name": "Path 5079",
    d: "M32,416h9.484v1.581H32Zm0,0",
    transform: "translate(-32 -406.516)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5080",
    "data-name": "Path 5080",
    d: "M112,448h1.581v1.581H112Zm0,0",
    transform: "translate(-104.097 -435.355)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5081",
    "data-name": "Path 5081",
    d: "M32,448h6.323v1.581H32Zm0,0",
    transform: "translate(-32 -435.355)",
    fill: "#f48116"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5082",
    "data-name": "Path 5082",
    d: "M169.525,347.461l-1.118-1.118-3.72,3.72,3.72,3.72,1.118-1.118-1.812-1.812h6v-1.581h-6Zm0,0",
    transform: "translate(-148.418 -312.128)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5083",
    "data-name": "Path 5083",
    d: "M73.581,79.644a.791.791,0,0,1,.79-.79H78l-1.812,1.812L77.3,81.784l3.72-3.72-3.72-3.72-1.118,1.118L78,77.273H74.371A2.374,2.374,0,0,0,72,79.644V93.87h1.581Zm0,0",
    transform: "translate(-64.887 -66.999)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5084",
    "data-name": "Path 5084",
    d: "M340.742,106.371v9.947l-1.812-1.812-1.118,1.118,3.72,3.72,3.72-3.72-1.118-1.118-1.812,1.812v-9.947A2.374,2.374,0,0,0,339.952,104H336v1.581h3.952A.791.791,0,0,1,340.742,106.371Zm0,0",
    transform: "translate(-302.806 -93.726)",
    fill: "#ff0185"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizableAnalytics);
export default __webpack_public_path__ + "static/media/CustomizableAnalytics.182f7881f196a6d5ac25095581e01967.svg";
export { ForwardRef as ReactComponent };